// extracted by mini-css-extract-plugin
module.exports = {"header":"_3FKze","headerTitle":"_1SQtL","headerDropdown":"Kv1m6","nameTooltip":"_3phPw","nameTooltipTitle":"_2_ywM","nameTooltipText":"_2xe78","nameTooltipItem":"cvQEx"};